import React from 'react';
import Input from '../../../components/ui/Input';

const SupplierFields = ({ formData, errors, onChange }) => {
  return (
    <div className="space-y-4 p-6 bg-primary/5 rounded-xl border border-primary/20">
      <div className="flex items-center gap-2 mb-4">
        <div className="w-8 h-8 bg-primary rounded-lg flex items-center justify-center">
          <span className="text-primary-foreground font-bold text-sm">S</span>
        </div>
        <h3 className="font-heading font-semibold text-lg">Supplier Information</h3>
      </div>
      <Input
        label="Business/Kitchen Name"
        type="text"
        name="businessName"
        placeholder="e.g., Mom's Kitchen, Spice Paradise"
        value={formData?.businessName}
        onChange={onChange}
        error={errors?.businessName}
        required
        description="This will be displayed to customers"
      />
      <div>
        <label className="block text-sm font-caption font-semibold mb-2">
          Service Description <span className="text-accent">*</span>
        </label>
        <textarea
          name="serviceDescription"
          value={formData?.serviceDescription}
          onChange={onChange}
          placeholder="Describe your culinary specialties, signature dishes, and what makes your kitchen unique..."
          rows={4}
          className={`w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-ring transition-smooth resize-none ${
            errors?.serviceDescription ? 'border-error' : 'border-input'
          }`}
        />
        {errors?.serviceDescription && (
          <p className="mt-1 text-sm text-error">{errors?.serviceDescription}</p>
        )}
        <p className="mt-1 text-xs text-muted-foreground">
          Minimum 50 characters. Tell customers about your cooking style and specialties.
        </p>
      </div>
      <Input
        label="Profile Image URL"
        type="url"
        name="profile_image"
        placeholder="https://your-image-url.com/profile.jpg"
        value={formData?.profile_image || ''}
        onChange={onChange}
        error={errors?.profile_image}
        description="Paste a direct link to your profile image (optional)"
      />
    </div>
  );
};

export default SupplierFields;